<template>
  <b-modal
    title="Modification conteneur"
    size="xl"
    :modal-class="'base-modal'"
    centered
    ref="editWrapperModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :lazy="true"
    @hide="close"
  >
    <b-container class="m-body">
      <ul class="wrapper-setting">
        <li class="setting-option">
          <div class="option-details">
            <h3>Taille de bordure</h3>
            <p class="description">
              Modifie la taille des bordures. En pixels.
            </p>
          </div>
          <div class="option-field">
            <div class="multi-input">
              <b-input-group size="sm" style="width: 200px">
                <template v-slot:prepend>
                  <b-input-group-text>Bordure (px)</b-input-group-text>
                </template>
                <b-form-input
                  min="0"
                  type="number"
                  v-model="bdWidth"
                ></b-form-input>
              </b-input-group>
            </div>
          </div>
        </li>
        <template v-if="this.bdWidth != 0">
          <li class="setting-option">
            <div class="option-details">
              <h3>Couleur de bordure</h3>
              <p class="description">
                Modifie la couleur des bordures.
              </p>
            </div>
            <div class="option-field">
              <div class="picker-wrapper">
                <button
                  type="button"
                  @click="
                    () =>
                      (this.showBorderColorPicker = !this.showBorderColorPicker)
                  "
                  class="picker-value"
                  :style="{ backgroundColor: borderColor }"
                >
                  <span class="picker-text">Selection de couleur</span>
                </button>
                <div class="color-picker">
                  <color-picker
                    v-if="showBorderColorPicker"
                    :sucker-hide="true"
                    :color="borderColor"
                    @changeColor="
                      color => (this.borderColor = this.toRgbaString(color))
                    "
                  />
                </div>
              </div>
            </div>
          </li>
          <li class="setting-option">
            <div class="option-details">
              <h3>Position de la bordure</h3>
              <p class="description">
                Choix de la position de la bordure.
              </p>
            </div>
            <div class="option-field">
              <div class="picker-wrapper">
                <div class="btn-toolbar">
                  <b-btn-group>
                    <b-button
                      :pressed="this.borderPosition.includes('all')"
                      @click="changeBorderPosition('all')"
                      variant="outline-primary"
                    >
                      Tout
                    </b-button>
                    <b-button
                      :pressed="this.borderPosition.includes('top')"
                      @click="changeBorderPosition('top')"
                      variant="outline-primary"
                    >
                      En haut
                    </b-button>
                    <b-button
                      :pressed="this.borderPosition.includes('right')"
                      @click="changeBorderPosition('right')"
                      variant="outline-primary"
                    >
                      A droite
                    </b-button>
                    <b-button
                      :pressed="this.borderPosition.includes('bottom')"
                      @click="changeBorderPosition('bottom')"
                      variant="outline-primary"
                    >
                      En bas
                    </b-button>
                    <b-button
                      :pressed="this.borderPosition.includes('left')"
                      @click="changeBorderPosition('left')"
                      variant="outline-primary"
                    >
                      A gauche
                    </b-button>
                  </b-btn-group>
                </div>
              </div>
            </div>
          </li>
        </template>
        <li class="setting-option">
          <div class="option-details">
            <h3>Espacement intérieurs</h3>
            <p class="description">
              Modifie les espacements intérieurs (en haut, à droite, en bas et à
              gauche) de l'élément. Exprimé en pixels.
            </p>
          </div>
          <div class="option-field">
            <div class="multi-input">
              <b-input-group size="sm" style="width: 100px">
                <template v-slot:prepend>
                  <b-input-group-text
                    ><font-awesome-icon :icon="['fas', 'arrow-up']"
                  /></b-input-group-text>
                </template>
                <b-form-input
                  min="0"
                  type="number"
                  v-model="paddingTop"
                ></b-form-input>
              </b-input-group>
              <b-input-group size="sm" style="width: 100px">
                <template v-slot:prepend>
                  <b-input-group-text
                    ><font-awesome-icon :icon="['fas', 'arrow-right']"
                  /></b-input-group-text>
                </template>
                <b-form-input
                  min="0"
                  type="number"
                  v-model="paddingRight"
                ></b-form-input>
              </b-input-group>
              <b-input-group size="sm" style="width: 100px">
                <template v-slot:prepend>
                  <b-input-group-text
                    ><font-awesome-icon :icon="['fas', 'arrow-down']"
                  /></b-input-group-text>
                </template>
                <b-form-input
                  min="0"
                  type="number"
                  v-model="paddingBottom"
                ></b-form-input>
              </b-input-group>
              <b-input-group size="sm" style="width: 100px">
                <template v-slot:prepend>
                  <b-input-group-text
                    ><font-awesome-icon :icon="['fas', 'arrow-left']"
                  /></b-input-group-text>
                </template>
                <b-form-input
                  min="0"
                  type="number"
                  v-model="paddingLeft"
                ></b-form-input>
              </b-input-group>
            </div>
          </div>
        </li>
        <li class="setting-option">
          <div class="option-details">
            <h3>Espacement extérieurs</h3>
            <p class="description">
              Modifie les espacements extérieurs (en haut et en bas) de
              l'élément. Exprimé en pixels.
            </p>
          </div>
          <div class="option-field">
            <div class="multi-input">
              <b-input-group size="sm" style="width: 100px">
                <template v-slot:prepend>
                  <b-input-group-text
                    ><font-awesome-icon :icon="['fas', 'arrow-up']"
                  /></b-input-group-text>
                </template>
                <b-form-input
                  min="0"
                  type="number"
                  v-model="marginTop"
                ></b-form-input>
              </b-input-group>
              <b-input-group size="sm" style="width: 100px">
                <template v-slot:prepend>
                  <b-input-group-text
                    ><font-awesome-icon :icon="['fas', 'arrow-down']"
                  /></b-input-group-text>
                </template>
                <b-form-input
                  min="0"
                  type="number"
                  v-model="marginBottom"
                ></b-form-input>
              </b-input-group>
            </div>
          </div>
        </li>
        <li
          v-if="this.wrapper && this.wrapper.type === 'colonne'"
          class="setting-option"
        >
          <div class="option-details">
            <h3>Alignement du contenu</h3>
            <p class="description">
              Choix de l'alignement du contenu (à gauche, au centre ou à
              droite).
            </p>
          </div>
          <div class="option-field">
            <div class="picker-wrapper">
              <div class="btn-toolbar">
                <b-btn-group>
                  <b-button
                    :pressed="this.alignItems === 'flex-start'"
                    @click="changeContentAlignement('flex-start')"
                    variant="outline-primary"
                  >
                    A gauche
                  </b-button>
                  <b-button
                    :pressed="this.alignItems === 'center'"
                    @click="changeContentAlignement('center')"
                    variant="outline-primary"
                  >
                    Au centre
                  </b-button>
                  <b-button
                    :pressed="this.alignItems === 'flex-end'"
                    @click="changeContentAlignement('flex-end')"
                    variant="outline-primary"
                  >
                    A droite
                  </b-button>
                </b-btn-group>
              </div>
            </div>
          </div>
        </li>
        <li class="setting-option">
          <div class="option-details">
            <h3>Couleur de fond</h3>
            <p class="description">
              Modifie la couleur de fond de l'élément.
            </p>
          </div>
          <div class="option-field">
            <div class="picker-wrapper">
              <button
                type="button"
                @click="toggleColorPicker"
                class="picker-value"
                :style="{ backgroundColor: backgroundColor }"
              >
                <span class="picker-text">Selection de couleur</span>
              </button>
              <div class="color-picker">
                <color-picker
                  v-if="showColorPicker"
                  :sucker-hide="true"
                  :color="backgroundColor"
                  @changeColor="changeColor"
                />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </b-container>

    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="close"
        >
          Annuler
        </b-button>
        <b-button variant="primary" size="md" @click="saveChanges">
          Valider
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import editElementDrop from '../edit/editElementDrop'
import editElementText from '../edit/editElementText'
import { mapActions, mapGetters } from 'vuex'
import colorPicker from '@caohenghu/vue-colorpicker'
import iconBase from '../../icons/iconBase'
import { defaultWrapperStyle } from '../../../config/constanteUse'

export default {
  components: {
    editElementDrop,
    editElementText,
    colorPicker,
    iconBase
  },
  data () {
    return {
      ...defaultWrapperStyle,
      borderPosition: ['all'],
      position: {
        '0': 'top',
        '1': 'right',
        '2': 'bottom',
        '3': 'left'
      },
      bdWidth: 0,
      wrapper: null,
      wrapperIndex: null,
      active: false,
      showColorPicker: false,
      showBorderColorPicker: false
    }
  },
  methods: {
    ...mapActions(['syncDataValue', 'setAddedToFiche', 'overwriteDroppedHeader', 'addDeletedHeader']),
    ...mapGetters(['droppedHeaders', 'isProjectTemplate']),
    close () {
      this.$refs['editWrapperModal'].hide()
      this.active = false
    },
    saveChanges () {
      this.wrapper.style.paddingTop = this.paddingTop + 'px'
      this.wrapper.style.paddingRight = this.paddingRight + 'px'
      this.wrapper.style.paddingBottom = this.paddingBottom + 'px'
      this.wrapper.style.paddingLeft = this.paddingLeft + 'px'
      this.wrapper.style.marginTop = this.marginTop + 'px'
      this.wrapper.style.marginBottom = this.marginBottom + 'px'
      this.wrapper.style.backgroundColor = this.backgroundColor
      this.wrapper.style.borderWidth = this.applyBorderPosition(this.borderPosition, this.bdWidth)
      this.wrapper.style.borderColor = this.borderColor
      this.wrapper.style.borderStyle = this.borderStyle
      this.wrapper.style.alignItems = this.alignItems
      this.$emit('wrapperUpdate', { index: this.wrapperIndex, wrapper: this.wrapper })
      this.close()
    },
    toRgbaString (color) {
      const { r, g, b, a } = color.rgba
      return `rgba(${r}, ${g}, ${b}, ${a})`
    },
    changeColor (color) {
      this.backgroundColor = this.toRgbaString(color)
    },
    toggleColorPicker () {
      this.showColorPicker = !this.showColorPicker
    },
    getBorderSize (size) {
      if (!size) {
        return 0
      }
      const sizes = size.split(' ')
      let res = 0
      sizes
        .map(sz => {
          if (sz.endsWith('px')) {
            return Number(sz.replace('px', ''))
          }
          return Number(sz)
        })
        .some(el => {
          if (el) {
            res = el
            return true
          } else {
            return false
          }
        })
      return res
    },
    changeBorderPosition (position) {
      const index = this.borderPosition.indexOf(position)

      if (position === 'all') {
        this.borderPosition = ['all']
        return
      }

      if (position !== 'all') {
        this.borderPosition = this.borderPosition.filter(el => el !== 'all')
      }

      if (index >= 0) {
        this.borderPosition.splice(index, 1)
      } else {
        this.borderPosition.push(position)
      }

      if (!this.borderPosition.length) {
        this.borderPosition = ['all']
      }
    },
    changeContentAlignement (position) {
      this.alignItems = position
    },
    getBorderPosition (size) {
      if (!size) {
        return ['all']
      }
      const sizes = size.split(' ')
      let res = ['all']

      const fsizes = sizes
        .map(sz => {
          if (sz.endsWith('px')) {
            return Number(sz.replace('px', ''))
          }
          return Number(sz)
        })

      if (fsizes.every(el => el > 0)) {
        return res
      }

      fsizes.forEach((el, index) => {
        if (el) {
          res.push(this.position[`${index}`])
        }
      })

      if (res.length > 1) {
        res.shift()
      }

      return res
    },
    applyBorderPosition (position, size) {
      let res
      /* switch (position) {
        case 'all':
          res = `${size}px ${size}px ${size}px ${size}px`
          break
        case 'top':
          res = `${size}px 0 0 0`
          break
        case 'right':
          res = `0 ${size}px 0 0`
          break
        case 'bottom':
          res = `0 0 ${size}px 0`
          break
        case 'left':
          res = `0 0 0 ${size}px`
          break
      } */
      if (position.includes('all')) {
        res = `${size}px ${size}px ${size}px ${size}px`
      } else {
        let mapped = {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
        res = Object.values(position
          .reduce((acc, curr) => {
            acc[curr] = `${size}px`
            return acc
          }, mapped))
          .join(' ')
      }
      return res
    },
    syncStyle (style) {
      this.paddingTop = style.paddingTop ? style.paddingTop.replace('px', '') : this.paddingTop
      this.paddingRight = style.paddingRight ? style.paddingRight.replace('px', '') : this.paddingRight
      this.paddingBottom = style.paddingBottom ? style.paddingBottom.replace('px', '') : this.paddingBottom
      this.paddingLeft = style.paddingLeft ? style.paddingLeft.replace('px', '') : this.paddingLeft
      this.marginTop = style.marginTop ? style.marginTop.replace('px', '') : this.marginTop
      this.marginBottom = style.marginBottom ? style.marginBottom.replace('px', '') : this.marginBottom
      this.backgroundColor = style.backgroundColor
      this.bdWidth = this.getBorderSize(style.borderWidth)
      this.borderColor = style.borderColor || this.borderColor
      this.borderPosition = this.getBorderPosition(style.borderWidth)
      this.alignItems = style.alignItems || this.alignItems
    },
    open (data) {
      this.wrapper = JSON.parse(JSON.stringify(data.element))
      this.wrapperIndex = data.elindex
      if (!this.wrapper.style) {
        this.wrapper.style = { ...defaultWrapperStyle }
      }
      this.syncStyle(this.wrapper.style)
      this.active = true
      this.$nextTick().then(() => {
        this.$refs['editWrapperModal'].show()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.m-body {
  max-height: 450px;
  overflow-y: auto;
  .fade-enter-active {
    transition: opacity 1s;
  }
  .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  ul {
    list-style: none;
    padding-left: 0;
    &.wrapper-setting {
      margin: 0;
      float: left;
      width: 100%;
      background-color: #ffffff;
    }
    .setting-option {
      border-bottom: 1px solid #ddd;
      float: left;
      display: inline-block;
      width: 95%;
      padding: 7.5px 2.5%;
      margin: 0;
      .option-details {
        width: 40%;
        float: left;
        display: inline-block;
        .description {
          color: #999;
          margin-bottom: 1em;
          font-size: 12px;
          font-style: italic;
        }
        h3 {
          font-size: 18px;
        }
      }
      .option-field {
        width: 50%;
        float: left;
        padding: 1.1em 0 0 10%;
        .multi-input {
          display: inline-flex;
          input {
            margin-right: 10%;
          }
        }
        .picker-wrapper {
          display: inline-block;
          .color-picker {
            .hu-color-picker {
              box-sizing: content-box;
            }
          }
          .picker-value {
            min-height: 31px;
            border-radius: 0 !important;
            box-shadow: none !important;
            margin: 0 6px 6px 0;
            padding: 0 0 0 30px;
            font-size: 11px;
            border: 1px solid #ccc;
            .picker-text {
              height: 100%;
              line-height: 30px;
              background-color: #f7f7f7;
              border-left: 1px solid #ccc;
              color: #555;
              display: block;
              padding: 0 6px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/editWrapper.vue